export default __webpack_public_path__ + "static/course-fe31f5059984a4d45ee4a0177208a359.svg";